import ReportSelectionModel from "./ReportSelectionModel";

export default class ReportEmailModel {
    userId: string = "";
    reportSelections : Record<string, ReportSelectionModel> | undefined;

    static from(json: string): ReportEmailModel {
        let model = Object.assign(new ReportEmailModel(), json);
        return model;
    }
}